<div class="page">
  <p>
    <strong>angular</strong>
    is licensed under the
    <strong>MIT License</strong>
    <br />
    Copyright (c) 2010-2025 Google LLC.
    <app-link [url]="'https://angular.dev/license'"></app-link>
  </p>

  <p>
    <strong>angular/components</strong>
    is licensed under the
    <strong>MIT License</strong>
    <br />
    Copyright (c) 2025 Google LLC.
  </p>

  <p>
    <strong>auth0/angular2-jwt</strong>
    is licensed under the
    <strong>MIT License</strong>
    <br />
    Copyright (c) 2017 Auth0 Inc.
  </p>

  <p>
    <strong>ctrl/ngx-emoji-mart</strong>
    is licensed under the
    <strong>MIT License</strong>
    <br />
    Copyright (c) Scott Cooper
  </p>

  <p>
    <strong>antonmedv/finder</strong>
    is licensed under the
    <strong>MIT License</strong>
    <br />
    Copyright (c) 2018 Anton Medvedev
  </p>

  <p>
    <strong>dotnet/aspnetcore</strong>
    is licensed under the
    <strong>MIT License</strong>
    <br />
    Copyright (c) .NET Foundation and Contributors
  </p>

  <p>
    <strong>ngx-translate/core</strong>
    is licensed under the
    <strong>MIT License</strong>
    <br />
    Copyright (c) 2018 Olivier Combe
    <br />
    Copyright (c) 2024 Andreas Löw / CodeAndWeb GmbH
  </p>

  <p>
    <strong>ngx-translate/http-loader</strong>
    is licensed under the
    <strong>MIT License</strong>
    <br />
    Copyright (c) 2018 Olivier Combe
  </p>

  <p>
    <strong>ddubrava/angular-yandex-maps</strong>
    is licensed under the
    <strong>MIT License</strong>
    <br />
    Copyright (c) 2025 Daniil Dubrava
  </p>

  <p>
    <strong>brix/crypto-js</strong>
    is licensed under the
    <strong>MIT License</strong>
    <br />
    Copyright (c) 2009-2013 Jeff Mott
    <br />
    Copyright (c) 2013-2016 Evan Vosberg
  </p>

  <p>
    <strong>lindell/JsBarcode</strong>
    is licensed under the
    <strong>MIT License</strong>
    <br />
    Copyright (c) 2016 Johan Lindell (johan@lindell.me)
  </p>

  <p>
    <strong>libphonenumber-js</strong>
    is licensed under the
    <strong>MIT License</strong>
    <br />
    Copyright (c) 2016 @catamphetamine &lt;purecatamphetamine@gmail.com&gt;
  </p>

  <p>
    <strong>lodash</strong>
    is licensed under the
    <strong>MIT License</strong>
    <br />
    Copyright JS Foundation and other contributors
    <app-link [url]="'https://js.foundation'"></app-link>
  </p>

  <p>
    <strong>broofa/mime</strong>
    is licensed under the
    <strong>MIT License</strong>
    <br />
    Copyright (c) 2023 Robert Kieffer
  </p>

  <p>
    <strong>orizens/ngx-infinite-scroll</strong>
    is licensed under the
    <strong>MIT License</strong>
    <br />
    Copyright (c) 2022 Oren Farhi
  </p>

  <p>
    <strong>AlexKhymenko/ngx-permissions</strong>
    is licensed under the
    <strong>MIT License</strong>
    <br />
    Copyright (c) 2017 AlexKhymenko
  </p>

  <p>
    <strong>soldair/node-qrcode</strong>
    is licensed under the
    <strong>MIT License</strong>
    <br />
    Copyright (c) 2012 Ryan Day
  </p>

  <p>
    <strong>Cordobo/angularx-qrcode</strong>
    is licensed under the
    <strong>MIT License</strong>
    <br />
    Copyright (c) 2018 - present Andreas Jacob (Cordobo)
  </p>

  <tui-accordion-item class="container">
    MIT License
    <ng-template tuiAccordionItemContent>
      <pre>
  The MIT License

  Permission is hereby granted, free of charge, to any person obtaining a copy
  of this software and associated documentation files (the "Software"), to deal
  in the Software without restriction, including without limitation the rights
  to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
  copies of the Software, and to permit persons to whom the Software is
  furnished to do so, subject to the following conditions:

  The above copyright notice and this permission notice shall be included in
  all copies or substantial portions of the Software.

  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
  IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
  FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
  AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
  LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
  OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
  THE SOFTWARE.
</pre
      >
    </ng-template>
  </tui-accordion-item>

  <p>
    <strong>taiga-family/taiga-ui</strong>
    is licensed under the
    <strong>Apache License 2.0</strong>
    <br />
    Copyright 2024 Acpekt
  </p>

  <p>
    <strong>taiga-family/maskito</strong>
    is licensed under the
    <strong>Apache License 2.0</strong>
    <br />
    Copyright 2024 Acpekt
  </p>

  <p>
    <strong>taiga-family/ng-web-apis</strong>
    is licensed under the
    <strong>Apache License 2.0</strong>
    <br />
    Copyright 2024 Acpekt
  </p>

  <p>
    <strong>taiga-family/ng-polymorpheus</strong>
    is licensed under the
    <strong>Apache License 2.0</strong>
    <br />
    Copyright 2024 Acpekt
  </p>

  <p>
    <strong>taiga-family/editor</strong>
    is licensed under the
    <strong>Apache License 2.0</strong>
    <br />
    Copyright 2024 Acpekt
  </p>

  <p>
    <strong>cure53/DOMPurify</strong>
    is licensed under the
    <strong>Apache License 2.0</strong>
    <br />
    Copyright 2025 Dr.-Ing. Mario Heiderich, Cure53
  </p>

  <p>
    <strong>ReactiveX/rxjs</strong>
    is licensed under the
    <strong>Apache License 2.0</strong>
    <br />
    Copyright (c) 2015-2025 
    Ben Lesh &lt;ben@benlesh.com&gt;
    Google, Inc.
    Netflix, Inc.
    Microsoft Corp.
    and contributors
  </p>

  <tui-accordion-item class="container">
    Apache License 2.0
    <ng-template tuiAccordionItemContent>
      <pre>
      Apache License
      Version 2.0, January 2004
  http://www.apache.org/licenses/

  TERMS AND CONDITIONS FOR USE, REPRODUCTION, AND DISTRIBUTION

  1. Definitions.

  "License" shall mean the terms and conditions for use, reproduction,
  and distribution as defined by Sections 1 through 9 of this document.

  "Licensor" shall mean the copyright owner or entity authorized by
  the copyright owner that is granting the License.

  "Legal Entity" shall mean the union of the acting entity and all
  other entities that control, are controlled by, or are under common
  control with that entity. For the purposes of this definition,
  "control" means (i) the power, direct or indirect, to cause the
  direction or management of such entity, whether by contract or
  otherwise, or (ii) ownership of fifty percent (50%) or more of the
  outstanding shares, or (iii) beneficial ownership of such entity.

  "You" (or "Your") shall mean an individual or Legal Entity
  exercising permissions granted by this License.

  "Source" form shall mean the preferred form for making modifications,
  including but not limited to software source code, documentation
  source, and configuration files.

  "Object" form shall mean any form resulting from mechanical
  transformation or translation of a Source form, including but
  not limited to compiled object code, generated documentation,
  and conversions to other media types.

  "Work" shall mean the work of authorship, whether in Source or
  Object form, made available under the License, as indicated by a
  copyright notice that is included in or attached to the work
  (an example is provided in the Appendix below).

  "Derivative Works" shall mean any work, whether in Source or Object
  form, that is based on (or derived from) the Work and for which the
  editorial revisions, annotations, elaborations, or other modifications
  represent, as a whole, an original work of authorship. For the purposes
  of this License, Derivative Works shall not include works that remain
  separable from, or merely link (or bind by name) to the interfaces of,
  the Work and Derivative Works thereof.

  "Contribution" shall mean any work of authorship, including
  the original version of the Work and any modifications or additions
  to that Work or Derivative Works thereof, that is intentionally
  submitted to Licensor for inclusion in the Work by the copyright owner
  or by an individual or Legal Entity authorized to submit on behalf of
  the copyright owner. For the purposes of this definition, "submitted"
  means any form of electronic, verbal, or written communication sent
  to the Licensor or its representatives, including but not limited to
  communication on electronic newsletter lists, source code control systems,
  and issue tracking systems that are managed by, or on behalf of, the
  Licensor for the purpose of discussing and improving the Work, but
  excluding communication that is conspicuously marked or otherwise
  designated in writing by the copyright owner as "Not a Contribution."

  "Contributor" shall mean Licensor and any individual or Legal Entity
  on behalf of whom a Contribution has been received by Licensor and
  subsequently incorporated within the Work.

  2. Grant of Copyright License. Subject to the terms and conditions of
  this License, each Contributor hereby grants to You a perpetual,
  worldwide, non-exclusive, no-charge, royalty-free, irrevocable
  copyright license to reproduce, prepare Derivative Works of,
  publicly display, publicly perform, sublicense, and distribute the
  Work and such Derivative Works in Source or Object form.

  3. Grant of Patent License. Subject to the terms and conditions of
  this License, each Contributor hereby grants to You a perpetual,
  worldwide, non-exclusive, no-charge, royalty-free, irrevocable
  (except as stated in this section) patent license to make, have made,
  use, offer to sell, sell, import, and otherwise transfer the Work,
  where such license applies only to those patent claims licensable
  by such Contributor that are necessarily infringed by their
  Contribution(s) alone or by combination of their Contribution(s)
  with the Work to which such Contribution(s) was submitted. If You
  institute patent litigation against any entity (including a
  cross-claim or counterclaim in a lawsuit) alleging that the Work
  or a Contribution incorporated within the Work constitutes direct
  or contributory patent infringement, then any patent licenses
  granted to You under this License for that Work shall terminate
  as of the date such litigation is filed.

  4. Redistribution. You may reproduce and distribute copies of the
  Work or Derivative Works thereof in any medium, with or without
  modifications, and in Source or Object form, provided that You
  meet the following conditions:

  (a) You must give any other recipients of the Work or
  Derivative Works a copy of this License; and

  (b) You must cause any modified files to carry prominent notices
  stating that You changed the files; and

  (c) You must retain, in the Source form of any Derivative Works
  that You distribute, all copyright, patent, trademark, and
  attribution notices from the Source form of the Work,
  excluding those notices that do not pertain to any part of
  the Derivative Works; and

  (d) If the Work includes a "NOTICE" text file as part of its
  distribution, then any Derivative Works that You distribute must
  include a readable copy of the attribution notices contained
  within such NOTICE file, excluding those notices that do not
  pertain to any part of the Derivative Works, in at least one
  of the following places: within a NOTICE text file distributed
  as part of the Derivative Works; within the Source form or
  documentation, if provided along with the Derivative Works; or,
  within a display generated by the Derivative Works, if and
  wherever such third-party notices normally appear. The contents
  of the NOTICE file are for informational purposes only and
  do not modify the License. You may add Your own attribution
  notices within Derivative Works that You distribute, alongside
  or as an addendum to the NOTICE text from the Work, provided
  that such additional attribution notices cannot be construed
  as modifying the License.

  You may add Your own copyright statement to Your modifications and
  may provide additional or different license terms and conditions
  for use, reproduction, or distribution of Your modifications, or
  for any such Derivative Works as a whole, provided Your use,
  reproduction, and distribution of the Work otherwise complies with
  the conditions stated in this License.

  5. Submission of Contributions. Unless You explicitly state otherwise,
  any Contribution intentionally submitted for inclusion in the Work
  by You to the Licensor shall be under the terms and conditions of
  this License, without any additional terms or conditions.
  Notwithstanding the above, nothing herein shall supersede or modify
  the terms of any separate license agreement you may have executed
  with Licensor regarding such Contributions.

  6. Trademarks. This License does not grant permission to use the trade
  names, trademarks, service marks, or product names of the Licensor,
  except as required for reasonable and customary use in describing the
  origin of the Work and reproducing the content of the NOTICE file.

  7. Disclaimer of Warranty. Unless required by applicable law or
  agreed to in writing, Licensor provides the Work (and each
  Contributor provides its Contributions) on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or
  implied, including, without limitation, any warranties or conditions
  of TITLE, NON-INFRINGEMENT, MERCHANTABILITY, or FITNESS FOR A
  PARTICULAR PURPOSE. You are solely responsible for determining the
  appropriateness of using or redistributing the Work and assume any
  risks associated with Your exercise of permissions under this License.

  8. Limitation of Liability. In no event and under no legal theory,
  whether in tort (including negligence), contract, or otherwise,
  unless required by applicable law (such as deliberate and grossly
  negligent acts) or agreed to in writing, shall any Contributor be
  liable to You for damages, including any direct, indirect, special,
  incidental, or consequential damages of any character arising as a
  result of this License or out of the use or inability to use the
  Work (including but not limited to damages for loss of goodwill,
  work stoppage, computer failure or malfunction, or any and all
  other commercial damages or losses), even if such Contributor
  has been advised of the possibility of such damages.

  9. Accepting Warranty or Additional Liability. While redistributing
  the Work or Derivative Works thereof, You may choose to offer,
  and charge a fee for, acceptance of support, warranty, indemnity,
  or other liability obligations and/or rights consistent with this
  License. However, in accepting such obligations, You may act only
  on Your own behalf and on Your sole responsibility, not on behalf
  of any other Contributor, and only if You agree to indemnify,
  defend, and hold each Contributor harmless for any liability
  incurred by, or claims asserted against, such Contributor by reason
  of your accepting any such warranty or additional liability.
  </pre
      >
    </ng-template>
  </tui-accordion-item>

  <p>
    <strong>avoidwork/filesize.js</strong>
    is licensed under the
    <strong>BSD 3-Clause "New" or "Revised" License</strong>
    <br />
    Copyright (c) 2025, Jason Mulligan
  </p>

  <tui-accordion-item class="container">
    BSD 3-Clause "New" or "Revised" License
    <ng-template tuiAccordionItemContent>
      <pre>
  Redistribution and use in source and binary forms, with or without
  modification, are permitted provided that the following conditions are met:

  * Redistributions of source code must retain the above copyright notice, this
    list of conditions and the following disclaimer.

  * Redistributions in binary form must reproduce the above copyright notice,
    this list of conditions and the following disclaimer in the documentation
    and/or other materials provided with the distribution.

  * Neither the name of filesize nor the names of its
    contributors may be used to endorse or promote products derived from
    this software without specific prior written permission.

  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
  AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
  IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
  DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE
  FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
  DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
  SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
  CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
  OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
  OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
  </pre
      >
    </ng-template>
  </tui-accordion-item>

  <p>
    <strong>lucide-icons/lucide</strong>
    is licensed under the
    <strong>ISC License</strong>
    <br />
    Copyright (c) for portions of Lucide are held by Cole Bemis 2013-2022 as part of Feather (MIT). All other copyright
    (c) for Lucide are held by Lucide Contributors 2025.
  </p>

  <tui-accordion-item class="container">
    ISC License
    <ng-template tuiAccordionItemContent>
      <pre>
  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted, provided that the above
  copyright notice and this permission notice appear in all copies.

  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
  WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
  MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
  ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
  WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
  ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF
  OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
  </pre
      >
    </ng-template>
  </tui-accordion-item>

  <p>
    <strong>tdlib/td</strong>
    is licensed under the
    <strong>Boost Software License 1.0</strong>
  </p>

  <tui-accordion-item class="container">
    Boost Software License 1.0
    <ng-template tuiAccordionItemContent>
      <pre>
  Boost Software License - Version 1.0 - August 17th, 2003

  Permission is hereby granted, free of charge, to any person or organization
  obtaining a copy of the software and accompanying documentation covered by
  this license (the "Software") to use, reproduce, display, distribute,
  execute, and transmit the Software, and to prepare derivative works of the
  Software, and to permit third-parties to whom the Software is furnished to
  do so, all subject to the following:

  The copyright notices in the Software and this entire statement, including
  the above license grant, this restriction and the following disclaimer,
  must be included in all copies of the Software, in whole or in part, and
  all derivative works of the Software, unless such copies or derivative
  works are solely in the form of machine-executable object code generated by
  a source language processor.

  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
  IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
  FITNESS FOR A PARTICULAR PURPOSE, TITLE AND NON-INFRINGEMENT. IN NO EVENT
  SHALL THE COPYRIGHT HOLDERS OR ANYONE DISTRIBUTING THE SOFTWARE BE LIABLE
  FOR ANY DAMAGES OR OTHER LIABILITY, WHETHER IN CONTRACT, TORT OR OTHERWISE,
  ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
  DEALINGS IN THE SOFTWARE.
  </pre
      >
    </ng-template>
  </tui-accordion-item>

  <p>
    <strong>microsoft/tslib</strong>
    is licensed under the
    <strong>BSD Zero Clause License</strong>
    <br />
    Copyright (c) Microsoft Corporation.
  </p>

  <tui-accordion-item class="container">
    BSD Zero Clause License
    <ng-template tuiAccordionItemContent>
      <pre>
  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.

  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  </pre
      >
    </ng-template>
  </tui-accordion-item>
</div>
